import stepIconClasses from "@mui/material/StepIcon/stepIconClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiStepIconTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                boxSizing: "border-box",
                [`&:not(.${stepIconClasses.completed})`]: {
                    borderRadius: dt.borderRadius.pill,
                    border: `1px solid ${dt.color.onSurface.key}`,
                    circle: {
                        fill: "transparent",
                    },
                    text: Object.assign(Object.assign({}, typographyResponsive(dt, "body2.medium")), { fill: dt.color.onSurface.key }),
                },
                [`&.${stepIconClasses.active}`]: {
                    borderColor: dt.color.palette.primary[50],
                    text: Object.assign(Object.assign({}, typographyResponsive(dt, "body2.medium")), { fill: dt.color.palette.primary[50] }),
                },
            },
        },
    };
};
